/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import { Button, Input, message, Modal, Spin } from 'antd';

import ReactResizeDetector from 'react-resize-detector';
import { useParams } from 'react-router-dom';

import marketQuizInfo from '../../../../../assets/market-quiz-info.png';
import { useStore, IQuizOption, IQuizResult } from '../../../store';
import FinalQuiz from '../../components/finalquiz';
import TopicContainer from '../../components/topicContainer';
import TopicItem from '../../components/topicItem';

import ImgNotPass from '../../../../../assets/market-notpass.png';
import ImgPass from '../../../../../assets/pass.png';

import './quiz.less';
import QuizReview from '../../components/quizReview';
import { ExclamationCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import html2canvas from 'html2canvas';
import { saveAs } from 'file-saver';
import {
  finishTrainingApi,
  formatDate,
  generateVerificationCode,
  pathToName,
  sendEmail,
} from './../../../../../api/quiz';
interface IQuizTopicProps {
  settings: any;
}

const QuizTopic: React.FunctionComponent<IQuizTopicProps> = ({ settings }) => {
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = 'quiz';
  const { updateParagraphState } = useStore();
  const {
    getQuizState,
    setQuizAnswer,
    reQuiz,
    getCourseState,
    setCourseState,
    language,
  } = useStore();
  let quizResult = getQuizState(p_course);
  const [state, setState] = React.useState<{
    inQuiz: boolean;
    containerWidth: number;
    current: number;
    diableScroll: boolean;
    loadingCert: boolean;
    name: string;
    downloadName: string;
    date: string;
    reviewlist: IQuizResult[];
    isNameEditable: boolean;
    code: string;
  }>({
    inQuiz: false,
    containerWidth: 0,
    current: 1,
    diableScroll: false,
    loadingCert: false,
    name: '',
    downloadName: '',
    date: '',
    reviewlist: [],
    isNameEditable: true,
    code: generateVerificationCode(),
  });
  const { name, isNameEditable } = state;
  const onResize = (w: any) => {
    setState({
      ...state,
      inQuiz: false,
      containerWidth: w,
    });
  };
  const next = () => {
    setState({
      ...state,
      current: state.current + 1,
      diableScroll: state.current + 1 > quizResult.results?.length,
      // date: quizResult.datetime?.toLocaleDateString() || '',
      date: formatDate(),
    });
    document?.querySelector('.final-quiz-container')?.scrollTo({
      top: 0,
      left: 0,
    });
  };
  const prev = () => {
    setState({
      ...state,
      current: state.current - 1,
    });
    document?.querySelector('.final-quiz-container')?.scrollTo({
      top: 0,
      left: 0,
    });
  };
  React.useEffect(() => {
    if (state.current > quizResult.results?.length && quizResult.isPassed) {
      updateParagraphState(p_course, p_topic, '2', 'completed', []);
      setTimeout(() => {
        setState({
          ...state,
          loadingCert: true,
          reviewlist: quizResult?.results
            .map((itm, idx) => ({
              ...itm,
              quizIndex: idx + 1,
            }))
            .filter((itm) => !itm.answer.isCorrect),
        });
        const courseState = getCourseState(p_course);
        setCourseState(p_course, {
          ...courseState,
          progress: courseState.progress + 20,
          step: courseState.step + 1,
        });
      }, 500);
    }
  }, [state.current, quizResult.isPassed]);
  const restest = () => {
    quizResult = reQuiz(p_course);
    setState({
      ...state,
      current: 1,
      diableScroll: true,
    });
    setTimeout(() => {
      setState({
        ...state,
        current: 1,
        diableScroll: false,
      });
    }, 500);
  };

  const [downLoading, setDownloading] = React.useState(false);
  // eslint-disable-next-line no-undef
  const setsSendEmail = (blob: BlobPart, filename: string) => {
    const file = new File([blob], filename, {
      type: 'image/png',
    });
    const formData = new FormData();
    const type = pathToName(p_course) || '';
    formData.append('file', file); // file是用户选择的文件
    formData.append('name', state.name);
    formData.append('code', state.code);
    formData.append('type', type);
    console.log(formData, state.name);
    sendEmail(formData);
  };
  const downloadImage = async (div: any, filename: string) => {
    try {
      const canvas = await html2canvas(div, { scale: 2 });
      canvas.toBlob(function (blob: any) {
        saveAs(blob, filename);
        if (process.env.REACT_APP_DOMAIN === 'cpttm') {
          setsSendEmail(blob, filename);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };
  const handleSaveName = () => {
    Modal.confirm(
      language === 'tc'
        ? {
            title: '請確認你輸入的名字是正確！',
            content: isNameEditable ? '確認後將無法修改。' : '',
            onOk: () => {
              setDownloading(true);
              downloadImage(
                document.getElementsByClassName('cert-area')[0],
                `HKirc-Cybersec-Training-Certification-${p_course}.png`
              ).then(() => {
                setDownloading(false);
              });
              setState({ ...state, isNameEditable: false });
            },
          }
        : {
            title: `Please confirm that you've entered your name correctly!`,
            content: isNameEditable
              ? 'You will not able to edit once confirmed.'
              : '',
            onOk: () => {
              setDownloading(true);
              downloadImage(
                document.getElementsByClassName('cert-area')[0],
                `HKirc-Cybersec-Training-Certification-${p_course}.png`
              ).then(() => {
                setDownloading(false);
              });
              setState({ ...state, isNameEditable: false });
            },
          }
    );
  };

  const [trainingId, setTrainingId] = React.useState('');

  React.useEffect(() => {
    if (p_course === 'general-staff-a') {
      setTrainingId('01');
    } else if (p_course === 'cybersecurity2024') {
      setTrainingId('02');
    } else if (p_course === 'student') {
      setTrainingId('03');
    } else if (p_course === 'senior-manager') {
      setTrainingId('04');
    } else if (p_course === 'finance') {
      setTrainingId('05');
    } else if (p_course === 'hr') {
      setTrainingId('06');
    } else if (p_course === 'market') {
      setTrainingId('07');
    } else if (p_course === 'customer') {
      setTrainingId('08');
    } else if (p_course === 'it') {
      setTrainingId('09');
    } else if (p_course === 'E-commerce') {
      setTrainingId('10');
    } else if (p_course === 'ngo') {
      setTrainingId('11');
    } else if (p_course === 'startup') {
      setTrainingId('12');
    } else {
      setTrainingId('');
    }
  }, [p_course]);

  const finishTraining = async () => {
    let retryAttempts = 0;
    let success = false;

    while (!success && retryAttempts < 2) {
      setState({
        ...state,
        code: generateVerificationCode(),
      });
      try {
        await finishTrainingApi({ id: trainingId });
        success = true;
      } catch (error) {
        console.log('Finish training failed, retrying...');
        retryAttempts++;
        await new Promise((resolve) => setTimeout(resolve, 1000));
      }
    }

    if (!success) {
      console.log('Finish training failed after multiple retries');
    }
  };

  React.useEffect(() => {
    if (quizResult.isPassed && trainingId !== '') {
      finishTraining();
    }
  }, [quizResult.isPassed, trainingId]);

  return (
    <TopicContainer className="quiz">
      <TopicItem className="course-landing intro" id="1" settings={[]}>
        <div className="course-landing-content ">
          <div className="quiz-text course-landing-text">
            <div className="title">{settings?.message}</div>
            <div
              className="description"
              dangerouslySetInnerHTML={{ __html: settings?.description }}
            />
          </div>
          <div className="landing-img ">
            <img style={{ bottom: 0 }} src={marketQuizInfo} alt="" />
          </div>
        </div>
      </TopicItem>
      <TopicItem className="" id="2" settings={[]}>
        <ReactResizeDetector onResize={onResize}>
          <div className="final-quiz-container">
            <div
              className="final-quiz-body"
              style={{
                width: state.containerWidth * (quizResult.results?.length + 1),
                left: -(state.current - 1) * state.containerWidth,
                transition: state.diableScroll
                  ? 'all 0s linear 0s'
                  : 'all 500ms linear 0s',
              }}
            >
              {quizResult.results?.map((quiz: any, index: any) => (
                <div
                  key={quizResult.quizId + index}
                  style={{
                    width:
                      state.containerWidth === 0
                        ? '100%'
                        : `${state.containerWidth}px`,
                  }}
                >
                  <FinalQuiz
                    quizIndex={index + 1}
                    quizCount={quizResult.results?.length}
                    question={quiz.question}
                    options={quiz.options}
                    onNext={next}
                    onPrev={prev}
                    onSubmit={(selected) => {
                      setQuizAnswer(
                        p_course,
                        quizResult.quizId,
                        quiz.id,
                        selected as IQuizOption
                      );
                    }}
                  />
                </div>
              ))}
              <div
                className="quiz-result"
                style={{
                  width:
                    state.containerWidth === 0
                      ? '100%'
                      : `${state.containerWidth}px`,
                }}
              >
                {quizResult.isPassed ? (
                  <>
                    <div className="quiz-result-pass">
                      <div className="left">
                        <div className="quiz-result-title">
                          {language === 'tc'
                            ? '恭喜!'
                            : language === 'sc'
                            ? '恭喜!'
                            : 'Congratulations!'}
                          {settings?.button && (
                            <a
                              href="https://forms.office.com/r/cmhxnU3zQy"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span>{settings?.button}</span>
                            </a>
                          )}
                        </div>
                        <p>
                          {language === 'tc' ? (
                            <>
                              祝賀您完成本課程的培訓。
                              <br /> 請填寫您的姓名並前往下載證書。
                            </>
                          ) : language === 'sc' ? (
                            <>
                              祝贺您完成本课程的培训。
                              <br /> 请填写您的姓名并前往下载证书。
                            </>
                          ) : (
                            <>
                              Congratulations on completing your training in
                              this course.
                              <br />
                              Please fill in your name and go to download the
                              certificate.
                            </>
                          )}
                        </p>
                        <div className="cert-download-input">
                          <Input
                            className="cert-name-input"
                            placeholder={
                              language === 'tc'
                                ? '輸入您的姓名'
                                : language === 'sc'
                                ? '输入您的姓名'
                                : 'Input your name'
                            }
                            value={name}
                            onChange={(e) => {
                              setState({
                                ...state,
                                name: (e.target as HTMLInputElement).value,
                              });
                            }}
                            disabled={!isNameEditable}
                          />
                          <Button
                            className="cert-download-button"
                            type="link"
                            onClick={() => {
                              if (state.name.length === 0) {
                                console.log('error');
                                message.error(
                                  language === 'tc'
                                    ? {
                                        content: '請輸入您的姓名',
                                        style: {
                                          fontSize: '20px',
                                        },
                                        icon: (
                                          <ExclamationCircleOutlined
                                            style={{
                                              fontSize: '25px',
                                              color: 'red',
                                            }}
                                          />
                                        ),
                                      }
                                    : language === 'sc'
                                    ? {
                                        content: '请输入您的姓名',
                                        style: {
                                          fontSize: '20px',
                                        },
                                        icon: (
                                          <ExclamationCircleOutlined
                                            style={{
                                              fontSize: '25px',
                                              color: 'red',
                                            }}
                                          />
                                        ),
                                      }
                                    : {
                                        content: 'Please input your name',
                                        style: {
                                          fontSize: '20px',
                                        },
                                        icon: (
                                          <ExclamationCircleOutlined
                                            style={{
                                              fontSize: '25px',
                                              color: 'red',
                                            }}
                                          />
                                        ),
                                      }
                                );
                              } else {
                                handleSaveName();
                              }
                            }}
                          >
                            {downLoading ? (
                              <Spin
                                indicator={
                                  <LoadingOutlined
                                    style={{ fontSize: 22, color: 'black' }}
                                    spin
                                  />
                                }
                              />
                            ) : (
                              <span>
                                {language === 'tc'
                                  ? '下載'
                                  : language === 'sc'
                                  ? '下载'
                                  : 'Download'}
                              </span>
                            )}
                          </Button>
                        </div>
                      </div>
                      <div className="right">
                        <img width="340px" src={ImgPass} alt="" />
                      </div>
                    </div>

                    <div className="cert-area">
                      {state.loadingCert &&
                        quizResult.isPassed &&
                        state.current > quizResult.results.length && (
                          <div className="cert-container">
                            {language === 'sc' ? (
                              <img
                                className="cert-bg"
                                src={
                                  p_course === 'cybersecurity2024'
                                    ? require(`../../../../../assets/cert/cert-general2024-${process.env.REACT_APP_DOMAIN}-sc.jpg`)
                                        .default
                                    : require(`../../../../../assets/cert/cert-${p_course}-${process.env.REACT_APP_DOMAIN}-sc.jpg`)
                                        .default
                                }
                                alt=""
                              />
                            ) : (
                              <img
                                className="cert-bg"
                                src={
                                  p_course === 'cybersecurity2024'
                                    ? require(`../../../../../assets/cert/cert-general2024-${process.env.REACT_APP_DOMAIN}.jpg`)
                                        .default
                                    : require(`../../../../../assets/cert/cert-${p_course}-${process.env.REACT_APP_DOMAIN}.jpg`)
                                        .default
                                }
                                alt=""
                              />
                            )}
                            <div className="cert-username">{state.name}</div>
                            <div className="cert-adate">{state.date}</div>
                            {process.env.REACT_APP_DOMAIN === 'cpttm' ? (
                              <div className="cert-code">{state.code}</div>
                            ) : null}
                          </div>
                        )}
                    </div>
                    {state.reviewlist.length <= 0 ? null : (
                      <div className="quiz-review-section">
                        <div className="quiz-result-title">
                          {language === 'tc'
                            ? '錯題集'
                            : language === 'sc'
                            ? '错题集'
                            : 'Set of wrong questions'}
                        </div>
                        {language === 'tc' ? (
                          <p className="content">
                            你一共做錯了 {state.reviewlist.length}{' '}
                            道題，以下是正確答案：
                          </p>
                        ) : language === 'sc' ? (
                          <p className="content">
                            你一共做错了 {state.reviewlist.length}{' '}
                            道题，以下是正确答案：
                          </p>
                        ) : (
                          <p>
                            You did a total of {state.reviewlist.length} wrong
                            Question, the following is the correct answer:
                          </p>
                        )}
                        {state.reviewlist.map((itm, idx) => (
                          <QuizReview
                            key={idx}
                            language={language}
                            question={itm.question}
                            options={itm.options}
                            quizIndex={itm.quizIndex || 0}
                            answer={itm.answer}
                          />
                        ))}
                      </div>
                    )}
                    <Button
                      className="next-topic-button"
                      type="text"
                      onClick={() => (window.location.href = '/')}
                    >
                      <div>
                        {language === 'tc'
                          ? '回到主頁'
                          : language === 'sc'
                          ? '回到主页'
                          : 'Back to home page'}
                      </div>
                    </Button>
                  </>
                ) : (
                  <div className="quiz-result-not-pass">
                    <div className="left">
                      <div className="quiz-result-title">
                        {language === 'tc'
                          ? '很抱歉'
                          : language === 'sc'
                          ? '很抱歉'
                          : 'Unfortunately'}
                      </div>
                      {language === 'en' ? (
                        <p>
                          You failed this quiz because your score was under 80
                          marks.
                          <br />
                          In order to receive a training certificate, you must
                          retake and pass the quiz.
                          <br />
                          Please study the previous training content carefully.
                        </p>
                      ) : language === 'sc' ? (
                        <p>
                          由于您的得分在80分以下，因此未通过此次测验。
                          <br />
                          为了获得培训证书，您必须重新完成并通过测验。
                          <br />
                          请再仔细学习先前的培训内容。
                        </p>
                      ) : (
                        <p>
                          由於您的得分在80分以下，因此未通過此次測驗。
                          <br />
                          為了獲得培訓證書，您必須重新完成並通過測驗。
                          <br />
                          請再仔細學習先前的培訓內容。
                        </p>
                      )}

                      <Button
                        onClick={restest}
                        className="quiz-retry-button"
                        type="link"
                      >
                        <span>
                          {language === 'tc'
                            ? '重新測驗'
                            : language === 'sc'
                            ? '重新测验'
                            : 'Retry'}
                        </span>
                      </Button>
                    </div>
                    <div className="right">
                      <img src={ImgNotPass} alt="" />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </ReactResizeDetector>
      </TopicItem>
    </TopicContainer>
  );
};

export default QuizTopic;
